import React from 'react';
import Typography from './Typography';
import backgroundcard from '../images/Rectangle 4410.png';

const OverviewCustomCard1 = ({ title, value, children, icon }) => {
    return (
        <div className="lg:px-4 md:px-3 px-1 relative lg:w-full md:w-[180px] w-[159px] lg:h-full md:h-[86px] h-[76px] ">
            <img src={backgroundcard} alt='backgroundcard' className='absolute top-0 left-0 w-full h-full' />
            <div className="relative z-10 flex lg:gap-[18px] md:gap-3 gap-1 items-center h-full text-white">
                <div className='my-auto'>{icon}</div>
                <div className='flex flex-col'>
                    {title && <Typography color={'#DF0F11'} className='mt-[30px]' size={'12px'} weight={400} lineheight={'170%'} text={title} />}
                    {value && <Typography color={'#FFF'} className='mb-5' text={value} family={'Supply'} size={'20px'} weight={500} lineheight={'170%'} />}
                </div>
            </div>
        </div>
    );
};

export default OverviewCustomCard1;